import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-move",
  "use": "icon-move-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-move\"><defs><style type=\"text/css\"></style></defs><path d=\"M113.6 400.448a111.552 111.552 0 1 1 0 223.104 111.552 111.552 0 0 1 0-223.104z m398.4 0a111.552 111.552 0 1 1 0 223.104 111.552 111.552 0 0 1 0-223.104z m398.4 0a111.552 111.552 0 1 1 0 223.104 111.552 111.552 0 0 1 0-223.104z\" p-id=\"2388\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol